// VORNX — central site configuration & launch-readiness flags.
// Fill in the social handles / payment flags when each channel goes live.
// Nothing here enables checkout: the site stays a luxury showcase until
// `features.payments` is turned on AND a provider is wired in.

export const SITE = {
  name: "VORNX",
  legalName: "VORNX",
  tagline: "Premium Home Fragrance",
  url: process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : ""),
  email: "info@vornxcollection.com",
  location: "Italy",
  country: "IT",

  // Social channels — leave "" to show a subtle "coming soon" state.
  // When ready, paste the full profile URL (e.g. "https://instagram.com/vornx").
  social: {
    instagram: "https://instagram.com/vornx_home_fragrance",
    facebook: "https://www.facebook.com/people/VORNX-Home-Fragrance/61592496934878/",
    tiktok: "",
    pinterest: "",
    // WhatsApp Business: use a wa.me link, e.g. "https://wa.me/39XXXXXXXXXX"
    whatsapp: "https://wa.me/393202753753",
  },

  // Future-facing flags. All payment providers are scaffolded but INACTIVE.
  features: {
    newsletter: true,
    checkout: false, // master switch — keep false (showcase only)
    payments: {
      enabled: false,
      providers: {
        stripe: false,
        paypal: false,
        applePay: false,
        googlePay: false,
      },
    },
  },

  // Signature Collection is the exclusive flagship line.
  signature: {
    limitedEditions: true,
    numberedEditions: true,
    fulfillment: "founder_managed", // manual, white-glove fulfillment
  },
};

export const hasAnySocial = () => Object.values(SITE.social).some((v) => v && v.length > 0);

// XL: future dedicated format. Set true (and re-add the URLs to backend/seo.py PAGES) when it is defined.
export const XL_PUBLISHED = false;
